import DialChart from "../molecules/DialChart";
import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import DegreeSection from "./DegreeSection";
import MeasurementResult from "./MeasurementResult";

export default function DetailPore({data, img}) {
    // 청결도 타입 3하고 4를 바꿔줘
    if(data.cleanlinessType === 2) {
        data.cleanlinessType = 3;
    } else if(data.cleanlinessType === 3) {
        data.cleanlinessType = 4;
    } else if(data.cleanlinessType === 4) {
        data.cleanlinessType = 2;
    }

    return (
        <MeasurementResult type="모공" 
                description="오래된 각질이 쌓이면 피부가 두꺼워지고 모공이 확대되며, 수분을 흡수하지 못하고 영양 성분을 유지하지 못하여 피부가 어두운 톤으로 변색되고 건조해지며, 유지 분비를 촉진해 모공이 더욱 확대됩니다." 
                score={data.score}>

            <div className="row-wrap">
                <div className="img-wrap">
                    <div className="img-cont">
                        <img src={img.image_cross_polar_front} />
                        <img src={img.image_mark_pore_front} />

                        <div className="caption">화이트 라이트</div>
                    </div>
                    <div className="img-cont">
                        <img src={img.image_uv_front} />
                        <img src={img.image_mark_pore_front} />
                        <div className="caption">UV</div>
                    </div>
                </div>

                <DegreeSection type="모공"
                    badge={data.analysisBadge}
                    items={[
                        {
                            value: "미세",
                        },
                        {
                            value: "비교적 확대 되었음",
                        },
                        {
                            value: "확대",
                        }
                    ]}
                    text={data.degreeText}
                    line={1}
                    height="70%"
                />
            </div>

            <div className="row-wrap">
                <section className="direction-row flex-content-center">
                    <div className="h4">
                        전체 안면부내
                        <br />
                        확대 모공면적
                        <br />
                        점유비율
                    </div>
                    <DialChart value={data.percentage} />
                </section>

                <section style={{transform: "translateY(-44%)"}}>
                    <div className="h4">청결도 상태 </div>

                    <div className="align-self-end">
                        <div className="point-graph">
                            {
                                [
                                    {
                                        value: "나쁨",
                                        level: 4
                                    },
                                    {
                                        value: "비교적 나쁨",
                                        level: 3
                                    },
                                    {
                                        value: "일반",
                                        level: 2
                                    },
                                    {
                                        value: "양호",
                                        level: 1
                                    },
                                ].map(el => {
                                    return (
                                        <div key={el.value} className={el.level >= data.cleanlinessType ? el.level == data.cleanlinessType ? "fill show-tooltip" : "fill" : ""}>
                                            <span className="point"></span>
                                            <span className="label">{el.value}</span>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </section>

                <section className="direction-row flex-content-center" style={{transform: "translateY(-44%)"}}>
                    <div className="h4">
                        안면내 각질
                        <br />
                        점유비
                    </div>
                    <DialChart value={data.jzsPercentage} />
                </section>
            </div>

            <div className="row-wrap" style={{alignItems: "flex-end", height: "118px"}}>
                <RelatedKeyword list={data.keyword} />

                <div style={{height: "164px"}}>
                    <AiAnalysisResult 
                    text={data.aiResult}
                    line={6}
                    hideTitle={true}
                    />
                </div>
            </div>
        </MeasurementResult>
    )
}